import objSet from 'lodash/set'
import objGet from 'lodash/get'
import { LangMap } from '../i18n'
const { en, ja, ko } = LangMap
// 设计稿默认的语言 设计只给IOS繁体中文(方块字)设计稿
const zhTW = LangMap['zh-TW']
const zhTW2 = LangMap['zh-TW2']
const zhMO = LangMap['zh-MO']

const DEFAULT_LANG = zhTW
// 特殊字体
const SPECIAL_FONT = ['Din Condensed', 'Helvetica Neue']

// 系统字体枚举
const DEFAULT_FONT_MAP = ['PingFang HK', 'Noto', 'SF Pro Text', 'Roboto']
// 系统默认字体
const DEFAULT_FONT = {
  square: {
    IOS: DEFAULT_FONT_MAP[0],
    android: DEFAULT_FONT_MAP[1]
  },
  letter: {
    IOS: DEFAULT_FONT_MAP[2],
    android: DEFAULT_FONT_MAP[3]
  }
}

// 特殊字体 Din Condensed
const D_FONT = {
  square: {
    IOS: DEFAULT_FONT_MAP[0],
    android: DEFAULT_FONT_MAP[1]
  },
  letter: {
    IOS: SPECIAL_FONT[0],
    android: SPECIAL_FONT[0]
  }
}

// 特殊字体 Helvetica Neue
const H_FONT = {
  square: {
    IOS: DEFAULT_FONT_MAP[0],
    android: DEFAULT_FONT_MAP[1]
  },
  letter: {
    IOS: SPECIAL_FONT[1],
    android: SPECIAL_FONT[1]
  }
}

// 字重隐射规则
// 100 - Thin
// 400 - Regular
// 500 - Medium
// 600 - Semi Bold
// 700 - Bold
const FONT_WEIGHT_RULE = {
  T: {
    500: 600
  },
  D: {
    500: 700
  },
  H: {
    500: 700
  }
}

// 方块字
const SQUARE_FONT = [zhTW, zhTW2, zhMO, ja, ko]

// 字母字
const LETTER_FONT = [en]

const toType = function(target: Object) {
  return Object.prototype.toString.call(target)
}

// 系统费字体 html 标签不能设置 font-family
const SYSTEM_FONT = process.server
  ? 'PingFang HK'
  : window.getComputedStyle(document.documentElement)[
      // @ts-ignore
      'font-family'
    ]

/**
 * @param {Object} obj 默认语言（设计稿）
 * @param {Function} call
 * @param {String} path 对象的属性路径 用于其他语言的映射赋值
 */
function deepStyle(obj: Object = {}, call: Function, path = '') {
  Object.keys(obj).forEach((key) => {
    if (key === 'style') {
      // @ts-ignore
      return call(obj[key], path + '.' + key)
    }
    // @ts-ignore
    if (toType(obj[key]) === '[object Object]') {
      // @ts-ignore
      return deepStyle(obj[key], call, path + '.' + key)
    }
  })
}

class Queue {
  _items = new Set()

  get items() {
    return this._items
  }

  enqueue(item: any) {
    this._items.add(item)
  }

  dequeue() {
    const head = this._items.values().next().value
    this._items.delete(head)
    return head
  }

  head() {
    return this._items.values().next().value
  }

  tail() {
    return [...this._items][this.size - 1]
  }

  get size() {
    return this._items.size
  }

  get isEmpty() {
    return this.size === 0
  }

  clear() {
    this._items.clear()
  }

  consume() {
    const setIterator = this.items.values()
    while (true) {
      const res = setIterator.next()
      if (res.done) {
        return
      }
      // @ts-ignore
      res.value()
    }
  }
}

// @ts-ignore
function propSet(target, path, value, actLang) {
  // 当前语言样式有值,且当前语言不是繁体则不覆盖
  if (objGet(target, path) && actLang !== DEFAULT_LANG) {
    return
  }
  // 自定义属性剔除
  if (path.includes('font-type')) return
  objSet(target, path, value)
}

export {
  DEFAULT_LANG,
  DEFAULT_FONT,
  SQUARE_FONT,
  LETTER_FONT,
  SPECIAL_FONT,
  SYSTEM_FONT,
  H_FONT,
  D_FONT,
  FONT_WEIGHT_RULE,
  DEFAULT_FONT_MAP,
  objSet,
  objGet,
  propSet,
  toType,
  deepStyle,
  Queue
}
